const whitelabelConfig = {
    'cluba': {
        'name': 'Club Allegiance',
        'cssClass': 'cluba',
        'copyright': 'Copyright © 2018-2023 cluballegiance.com All Rights Reserved.',
        'lppVisible': true,
        'howToSellVisible': true,
        'IPVisible': false,
        'ReferrerVisible': true,
        // 'homeURL': 'https://www.example.com/light',
        // 'logoURL': '/img/logo.82b9c7a5.png',
        // 'contactEmail':  'light@example.co.uk',
    },
    'malaki': {
        'name': 'Malaki cash',
        'cssClass': 'malaki',
        'copyright': 'Copyright © 2020-2023 malakicash.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': true,
        'IPVisible': true,
        'ReferrerVisible': false,
        // 'scssVariables': '../src/styles/whitelabel-variables/dark',
        // 'homeURL': 'https://www.example.com/dark',
        // 'logoURL': '/img/logo.82b9c7a5.png',
        // 'contactEmail':  'dark@example.co.uk',
    },
    'coolcashstash': {
        'name': 'Cool Cash Stash',
        'cssClass': 'coolcashstash',
        'copyright': 'Copyright © 2020-2023 coolcashstash.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': false,
        'IPVisible': true,
        'ReferrerVisible': true,
    },
    'emarket': {
        'name': 'Cool Cash Stash Emarket',
        'cssClass': 'emarket',
        'copyright': 'Copyright © 2020-2023 emarketershub.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': false,
        'IPVisible': true,
        'ReferrerVisible': true,
    },
    'iwatchrevenue': {
        'name': 'I Watch Revenue',
        'cssClass': 'iwatchrevenue',
        'copyright': 'Copyright © 2020-202 iwatchrevenue.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': false,
        'IPVisible': true,
        'ReferrerVisible': true,
    },
    'therhizomes': {
        'name': 'Therhizomes',
        'cssClass': 'therhizomes',
        'copyright': 'Copyright © 2023 therhizomes.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': false,
        'IPVisible': true,
    },
    'coolwatersplash': {
        'name': 'Cool Water Splash',
        'cssClass': 'coolwatersplash',
        'copyright': 'Copyright © 2020-2023 coolwatersplash.com All Rights Reserved.',
        'lppVisible': false,
        'howToSellVisible': false,
        'IPVisible': true,
        'ReferrerVisible': true,
    }
}

export default whitelabelConfig;
